import * as React from "react";

import { MyBagPresentationItem } from "../model";

import {
  MyBagOutOfStockUserExperience_ControllerInterface,
  useMyBagOutOfStockPresentationModel,
  useMyBagOutOfStockUserExperience,
  useMyBagOutOfStockUserExperience_asController,
} from "../providers";

export const DrawerFragment_OutOfStock_Content: React.FunctionComponent = (
  props
) => {
  const {
    presentationOutOfStockItems: presentationOutOfStockItems_currentServerState,
  } = useMyBagOutOfStockPresentationModel();
  const { isLoadingRemoveAll_canOnlyRemoveOneItemForeachCall } =
    useMyBagOutOfStockUserExperience();
  const { handleRemoveOutOfStockItem, handleRemoveAllOutOfStockitems } =
    useMyBagOutOfStockUserExperience_asController();

  const [presentationOutOfStockItems, setPresentationOutOfStockItems] =
    React.useState(() => presentationOutOfStockItems_currentServerState);
  React.useEffect(() => {
    if (!isLoadingRemoveAll_canOnlyRemoveOneItemForeachCall) {
      setPresentationOutOfStockItems(
        presentationOutOfStockItems_currentServerState
      );
    }
  }, [
    presentationOutOfStockItems_currentServerState,
    isLoadingRemoveAll_canOnlyRemoveOneItemForeachCall,
  ]);

  const outOfStockItemsList = React.useMemo(() => {
    if (presentationOutOfStockItems.length < 1) {
      return null;
    }
    return (
      <ul>
        {presentationOutOfStockItems.map((outOfStockItem) => {
          return (
            <li key={outOfStockItem.id}>
              <OutOfStockItem
                presentationMyBagItem={outOfStockItem}
                handleRemoveOutOfStockItem={handleRemoveOutOfStockItem}
              />
            </li>
          );
        })}
      </ul>
    );
  }, [presentationOutOfStockItems]);

  return (
    <section className="bbnt-checkout-2022-out-of-stock-drawer-content">
      <h1>{`Some of your items are unavailable.`}</h1>
      <p>{`Please remove them from your bag in order to proceed with checkout.`}</p>
      {outOfStockItemsList}
      {presentationOutOfStockItems.length > 1 ? (
        <button
          className="update-items"
          onClick={handleRemoveAllOutOfStockitems}
        >{`Remove all items`}</button>
      ) : null}
    </section>
  );
};

interface OutOfStockItemProps {
  presentationMyBagItem: MyBagPresentationItem;
  handleRemoveOutOfStockItem: MyBagOutOfStockUserExperience_ControllerInterface["handleRemoveOutOfStockItem"];
}
const OutOfStockItem: React.FunctionComponent<OutOfStockItemProps> = (
  props
) => {
  const handleRemoveThisItem = React.useCallback(() => {
    props.handleRemoveOutOfStockItem(props.presentationMyBagItem);
  }, [props.handleRemoveOutOfStockItem]);
  const productImage = React.useMemo(() => {
    return (
      <img
        src={props.presentationMyBagItem.imageThumbnail}
        alt={props.presentationMyBagItem.title}
      />
    );
  }, [
    props.presentationMyBagItem.title,
    props.presentationMyBagItem.imageThumbnail,
  ]);
  const title = React.useMemo(() => {
    return <p className="title">{props.presentationMyBagItem.title}</p>;
  }, [props.presentationMyBagItem.title]);
  const actions = React.useMemo(() => {
    return (
      <React.Fragment>
        <button
          className="remove-item"
          onClick={handleRemoveThisItem}
        >{`Remove`}</button>
      </React.Fragment>
    );
  }, []);
  return (
    <React.Fragment>
      <div className="lhs">
        {productImage}
        {props.presentationMyBagItem.serverErrors.length > 0 ? (
          props.presentationMyBagItem.serverErrors.map((message, index) => (
            <p key={index}>{message}</p>
          ))
        ) : (
          <p>{`Out of stock`}</p>
        )}
      </div>
      <div className="rhs">
        {title}
        {actions}
      </div>
    </React.Fragment>
  );
};
